export default "Ist Ihr Urlaub schon gebucht?";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/1/type/vacation/booked/question.js